export const LOGIN = '/login';
export const HOME = '/home';
export const TICKETS = '/tickets';
export const CHATS = '/chats';
export const INVOICES = '/invoices';
export const CHAT = '/chats/:chatId';
export const TICKET_CREATE = '/tickets/create';
export const TICKET = '/tickets/:ticketId';
export const TICKET_CREATE_FORM = '/tickets/form';
export const TICKET_TEMPLATE = '/ticketTemplates/:ticketTemplateId';
export const PASSWORD_RECOVERY = '/passwordRecovery';
export const PROFILE = '/profile';
